function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.25273437,280.731641 L2.85834533,277.600858 L102.211177,89.0833546 L58.0613266,5.6082033 C54.3920011,-1.28304578 45.0741245,0.473674398 43.8699203,8.18789086 L1.25273437,280.731641 Z",
  id: "path-1"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-50%",
  y: "-50%",
  width: "200%",
  height: "200%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 17.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
  type: "matrix",
  in: "shadowInnerInner1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M134.417103,148.974235 L166.455722,116.161738 L134.417104,55.1546874 C131.374828,49.3635911 123.983911,48.7568362 120.973828,54.5646483 L103.26875,88.6738296 L102.739423,90.4175473 L134.417103,148.974235 Z",
  id: "path-3"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-50%",
  y: "-50%",
  width: "200%",
  height: "200%",
  filterUnits: "objectBoundingBox",
  id: "filter-4"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: -9,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.09 0",
  type: "matrix",
  in: "shadowInnerInner1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0,282.99762 L2.12250746,280.0256 L102.527363,89.5119284 L102.739423,87.4951323 L58.478806,4.35817711 C54.7706269,-2.60604179 44.3313035,-0.845245771 43.1143483,6.95065473 L0,282.99762 Z",
  fill: "#FFC24A"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "#FFA712",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M135.004975,150.380704 L167.960199,116.629461 L134.995423,53.6993114 C131.866109,47.7425353 123.128817,47.7253411 120.032618,53.6993112 L102.421015,87.2880848 L102.421015,90.1487443 L135.004975,150.380704 Z",
  fill: "#F4BD62"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "#FFA50E",
  fillRule: "evenodd",
  xlinkHref: "#path-3"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-4)",
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F6820C",
  points: "0 282.99762 0.962097168 282.030396 4.45771144 280.60956 132.935323 152.60956 134.563025 148.178595 102.513123 87.1048584"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.120971,347.551268 L255.395916,282.703666 L222.191698,78.2093373 C221.153051,71.8112478 213.303658,69.2818149 208.724314,73.8694368 L0.000254726368,282.997875 L115.608454,347.545536 C122.914643,351.624979 131.812872,351.62689 139.120971,347.551268",
  fill: "#FDE068"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.354084,282.159837 L221.401937,79.2179369 C220.371175,72.8684188 213.843792,70.2409553 209.299213,74.79375 L1.28945312,282.600785 L115.627825,346.509458 C122.878548,350.557931 131.709226,350.559827 138.961846,346.515146 L254.354084,282.159837 Z",
  fill: "#FCCA3F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.120907,345.64082 C131.812808,349.716442 122.914579,349.714531 115.60839,345.635089 L0.93134768,282.014551 L0.000191044776,282.997875 L115.60839,347.545536 C122.914579,351.624979 131.812808,351.62689 139.120907,347.551268 L255.395853,282.703666 L255.111196,280.951785 L139.120907,345.64082 Z",
  fill: "#EEAB37"
}));

var SvgFirebase = function SvgFirebase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "351px",
    viewBox: "0 0 256 351",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFirebase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/firebase.bfa69c4f.svg";
export { ForwardRef as ReactComponent };